
import React from 'react';
import { inject, observer } from "mobx-react";
import * as mobx from 'mobx'
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

//const currency = "^\$?\-?([1-9]{1}[0-9]{0,2}(\,\d{3})*(\.\d{0,2})?|[1-9]{1}\d{0,}(\.\d{0,2})?|0(\.\d{0,2})?|(\.\d{1,2}))$|^\-?\$?([1-9]{1}\d{0,2}(\,\d{3})*(\.\d{0,2})?|[1-9]{1}\d{0,}(\.\d{0,2})?|0(\.\d{0,2})?|(\.\d{1,2}))$|^\(\$?([1-9]{1}\d{0,2}(\,\d{3})*(\.\d{0,2})?|[1-9]{1}\d{0,}(\.\d{0,2})?|0(\.\d{0,2})?|(\.\d{1,2}))\)$"

//can't create a new one without adding atleast greater than 0


const styles = theme => ({
  root: {
    flexGrow: 1,
    minHeight: 400,
    margin: theme.spacing.unit * 2,
  },
  margin: {
    marginLeft: theme.spacing.unit * 2,
  },
  withoutLabel: {
    marginTop: theme.spacing.unit * 3,
  },
  textField: {
    flexBasis: 200,
  },
  card: {
    margin: theme.spacing.unit * 3,
    width: '100%',
  },
  title: {
    marginBottom: 16,
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
});


@inject("commonStore")
@inject("authStore")
@observer
class Budget extends React.Component {
  state = {
    newBalance: 0,
  };

  componentDidMount() {
    const { campaignID, amount, handleUpdate, commonStore } = this.props
    const { campaign } = commonStore
    const { balance, priceMapType } = campaign
    if(campaignID){
      this.setState({newBalance: balance ? balance + amount : 0})
    }else{
      this.setState({newBalance: amount})
    }
    this.props.authStore.syncUser()
  }
  handleChange = event => {
    console.log(event.target.value)
    const value = event.target.value
    this.handleBalanceUpdate(value)
  };
  handleBalanceUpdate = value => {

    const { handleUpdate, commonStore } = this.props
    const { balance } = commonStore.campaign
    const { credit } = commonStore.agent

    if(value === 0 || value === ''|| value === undefined || value === null){
      this.setState({newBalance: 0})
      handleUpdate('amount', 0, true)
      return
    }

    const newBalance = value * 100

    if(parseInt(newBalance)){
        let isValid = true
        if (newBalance > credit){
          let isValid = false
        }
        console.log(newBalance)
        console.log(balance)
        const amount = newBalance - (balance ? balance : 0)
        this.setState({newBalance})
        console.log(amount)
        handleUpdate('amount', amount, isValid)
    }

  }
  makeQuickButtons = () => {
    const { handleUpdate, commonStore } = this.props
    const { balance } = commonStore.campaign
    const { credit } = commonStore.agent
    let dollars = 100
    const arrayOfButtons = []
      for (let i = 0; i < 10; i++) { 
        if (dollars < (credit / 100) + .01){
          const newBalance = dollars * 1
        arrayOfButtons.push(
          <Button key={dollars} onClick={() => {this.handleBalanceUpdate(newBalance)}}> {`$${dollars}`} </Button>
        )
      }
      dollars = dollars + 100
    }
    return arrayOfButtons
  }
  render() {
    const { newBalance } = this.state
    const { classes, commonStore, campaignID, priceMapType } = this.props;
    const { credit } = commonStore.agent
    const { balance } = commonStore.campaign
    const quickButtons = this.makeQuickButtons()
    

    return (
      <div className={classes.root}>
      {quickButtons.length > 0 ? 'Quick Select Amount' : null }
      {quickButtons}
      {/*<Typography className={classes.title} color="textSecondary">
      {campaignID ? `Your campaigns current balance is $${balance / 100}.00` : null}
    </Typography>*/}
      <Card className={classes.card}>
     

      {priceMapType ?
        <CardContent>
            <Typography className={classes.title} color="textSecondary">
             {`Your current campaign balance is $${(balance ? balance : 0) / 100}.00`}
            </Typography>
      
        <FormControl fullWidth className={classes.margin}>
          <InputLabel htmlFor="adornment-amount">New Campaign Balance:</InputLabel>
          <Input
            id="adornment-amount"
            value={newBalance / 100}
            onChange={this.handleChange}
            startAdornment={<InputAdornment position="start">$</InputAdornment>}
          />

          <Typography className={classes.title} color="textSecondary">
          {`New adjusted campaign balance will be $${(newBalance) / 100  }.00`}
          </Typography>
          <Typography className={classes.title} color="textSecondary">
          {`After this update your available account credit will be $${((credit + ((balance ? balance : 0) - newBalance)) / 100).toFixed(2)}`}
          </Typography>
   
        </FormControl>    </CardContent>:
        <CardContent>
            <Typography className={classes.title} color="textSecondary">
            {`Please create a new campaign. This campaign cannot increase its balance due to price changes`}
            </Typography>
            </CardContent>
        }
     </Card>
     <Typography className={classes.title} color="textSecondary">
    </Typography>
      </div>
    );
  }
}

Budget.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Budget);


// WEBPACK FOOTER //
// ./src/components/Leads/Campaigns/ManageCampaign/Options/Budget.js